import { z } from 'zod';
import { EInvoiceFormat } from '../schemas/EInvoiceSchema';

export const PartnerDirectoryQuerySchema = z.object({
  limit: z.number().int().min(1).max(100).default(25),
  offset: z.number().int().min(0).max(100_000).default(0),
  q: z.string().trim().max(200).default(''),
  role: z.enum(['ALL', 'CUSTOMER', 'SUPPLIER', 'BOTH']).default('ALL'),
  sort: z.enum(['name_asc', 'updated_desc']).default('name_asc'),
});
export type PartnerDirectoryQuery = z.infer<typeof PartnerDirectoryQuerySchema>;
export const PartnerDirectoryRecordSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  type: z.enum(['CUSTOMER', 'SUPPLIER', 'BOTH']),
  contactEmail: z.string().nullable(),
  customerNumber: z.string().nullable(),
  supplierNumber: z.string().nullable(),
  city: z.string().nullable(),
  countryCode: z.string().nullable(),
  eInvoiceFormatOverride: EInvoiceFormat.nullable(),
  updatedAt: z.string().nullable(),
});
export type PartnerDirectoryRecord = z.infer<typeof PartnerDirectoryRecordSchema>;
export const PartnerDirectoryPageSchema = z.object({
  data: z.array(PartnerDirectoryRecordSchema).max(100),
  pagination: z.object({
    limit: z.number().int().min(1).max(100),
    offset: z.number().int().min(0).max(100_000),
    total: z.number().int().nonnegative(),
    hasMore: z.boolean(),
  }),
});
export type PartnerDirectoryPage = z.infer<typeof PartnerDirectoryPageSchema>;
export const PartnerDirectorySelectionSchema = z.object({
  ids: z.array(z.string().min(1).max(128)).min(1).max(100).refine(ids => new Set(ids).size === ids.length, 'Partner selection must be unique'),
});
